import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@orijinworks/frontend-commons';
import { AutocompleteSkeleton, AutocompleteOption } from '../sections';
import {
  membersAutocompleteSx,
  searchIcon,
} from '../AttorneyModal.styles';
import { useAutocompleteStyles } from './AttorneyAutocomplete.styles';
import { useAttorneyAutocomplete } from './useAttorneyAutocomplete';

const AttorneyAutocomplete = ({
  memberOptions = [],
  selectedMembers = [],
  onMembersChange,
  onSearchChange,
  isMaxMembersReached = false,
  isMemberListLoading = false,
  showDisplayNamesOnly = false,
  filterOptions,
  getOptionLabel,
  isOptionEqualToValue,
}) => {
  const classes = useAutocompleteStyles();
  const { handleChange, handleInputChange, getOptionProps, popperProps } =
    useAttorneyAutocomplete({
      memberOptions,
      selectedMembers,
      onMembersChange,
      onSearchChange,
      showDisplayNamesOnly,
    });

  return (
    <Box className="attorney-autocomplete-root">
      <Autocomplete
        multiple
        options={memberOptions}
        value={selectedMembers}
        disabled={isMaxMembersReached}
        disableClearable={true}
        disableCloseOnSelect={false}
        disablePortal={false}
        noOptionsText={null}
        getOptionLabel={getOptionLabel}
        filterOptions={filterOptions}
        isOptionEqualToValue={isOptionEqualToValue}
        renderTags={() => null}
        onChange={handleChange}
        onInputChange={handleInputChange}
        className={classes.autocompleteRoot}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Members"
            placeholder="Search"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={searchIcon} />
                </InputAdornment>
              ),
              endAdornment: params.InputProps?.endAdornment || null,
            }}
            sx={membersAutocompleteSx}
          />
        )}
        PopperProps={popperProps}
        renderOption={(option) => {
          const optionProps = getOptionProps(option);
          return <AutocompleteOption {...optionProps} />;
        }}
        ListboxComponent={({ children, ...other }) => (
          <div {...other}>
            {isMemberListLoading ? <AutocompleteSkeleton /> : children}
          </div>
        )}
      />
    </Box>
  );
};

export default AttorneyAutocomplete;

